import { allComparisons } from 'content-collections'
import { visibleSorted } from '#app/utils/content.ts'
import { buildMeta, collectionJsonLd } from '#app/utils/seo.ts'
import { ContentIndex } from '../components/content-index'
import { type Route } from './+types/index.ts'

const TOOLS_TITLE = 'Best Backlink Tools | Competitor Backlinks'
const TOOLS_DESCRIPTION =
	'Honest, hands-on comparisons of the best backlink tools, plus a straight answer on when a free approach is genuinely enough.'

export const meta: Route.MetaFunction = () => [
	...buildMeta({
		title: TOOLS_TITLE,
		description: TOOLS_DESCRIPTION,
		path: '/best-tools',
		image: '/img/og/best-tools.png',
	}),
	{
		'script:ld+json': collectionJsonLd({
			title: TOOLS_TITLE,
			description: TOOLS_DESCRIPTION,
			name: 'Best tools',
			path: '/best-tools',
			items: visibleSorted(allComparisons).map((doc) => ({
				title: doc.title,
				path: `/best-tools/${doc.slug}`,
			})),
		}),
	},
]

export default function BestToolsIndex() {
	return (
		<ContentIndex
			eyebrow="Best tools"
			title="Honest comparisons of the best backlink tools"
			description="Head-to-head breakdowns of the tools worth your money, with clear affiliate disclosure and a straight answer on when free will do."
			basePath="/best-tools"
			entries={visibleSorted(allComparisons)}
		/>
	)
}
